import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

// Reusable landing-style header (logo + nav).
// `showFeatures` hides the Features link (e.g. on the login/register form page).
const LandingHeader = ({ showFeatures = true }) => {
  return (
    <>
      <header className="cl-header cl-header--standalone">
        <div className="cl-header__inner">
          <Link to="/" className="cl-brand">
            <span className="cl-brand__mark cl-brand__mark--logo">
              <img
                src="https://jaipuria.edu.in/wp-content/uploads/2021/07/sajes_great_place_logo.jpg"
                
                alt="Jaipuria Community Library logo"
              />
            </span>
            <span className="cl-brand__text">Jaipuria Community Library Management System</span>
          </Link>

          <nav className="cl-nav">
            {showFeatures && <a href="#features" className="cl-nav__link">Features</a>}
            <Link to="/login" state={{ showRegister: false }} className="cl-nav__link">Login</Link>
            <Link to="/login" state={{ showRegister: true }} className="cl-btn cl-btn--ghost cl-btn--sm">Register</Link>
          </nav>
        </div>
      </header>
      <div className="cl-header-spacer" />
    </>
  );
};

export default LandingHeader;
